'use es6';

const isNil = value => value == null;
const serialize = (key, value) => `${encodeURIComponent(key)}=${encodeURIComponent(isNil(value) ? '' : value)}`;
const decode = value => isNil(value) ? '' : decodeURIComponent(value);
export const buildQueryString = obj => {
  if (isNil(obj) || typeof obj !== 'object') {
    return '';
  }
  return Object.keys(obj).reduce((state, key) => {
    state.push(serialize(key, obj[key]));
    return state;
  }, []).join('&');
};
export const parseQueryString = queryString => {
  if (isNil(queryString) || typeof queryString !== 'string') {
    return {};
  }
  return (queryString.startsWith('?') ? queryString.substring(1) : queryString).split('&').reduce((state, item) => {
    const [key, value] = item.split('=');
    if (isNil(key) || key === '') {
      return state;
    }
    state[key] = decode(value);
    return state;
  }, {});
};